import "./style.scss";
import logo from "../../assets/img/valesul-diamond.svg";

export function HeaderLogo () {
  return (
    <div className="header-logo">
      <img src={logo} className="logo" alt="Logo vale sul shopping" />
    </div>
  )
}